import { IConfigKey } from './loadOcppConfigKeys'

const setOcppConfigValue = (key: string, value: string, configKeys: IConfigKey[]): Array<IConfigKey> | null => {
    if (!configKeys || configKeys.length === 0) {
        return null
    }

    return configKeys.map((item) => ({ ...item, ...(item.key === key && { value }) }))
}

export default setOcppConfigValue
